/*
  berry-drag-scroll — reusable horizontal drag/scroll helper.

  Applied via the [data-drag-scroll] attribute to any overflow-x row. Provides:
    • Desktop click-and-hold drag to scroll (mouse/pen pointers only), with a
      grab/grabbing cursor. Touch pointers are left untouched so native momentum
      swipe keeps working on mobile.
    • Edge-fade state: toggles is-start / is-end classes on the row's parent so a
      CSS overlay can hint that there is more content to the left/right.

  No auto-scroll, no marquee, no dependencies. Namespaced under BerryDragScroll.
*/
(function () {
  'use strict';

  var DRAG_THRESHOLD = 3; // px moved before a drag suppresses the click

  function updateEdges(row) {
    var host = row.parentElement;
    if (!host) { return; }
    var max = row.scrollWidth - row.clientWidth;
    var atStart = row.scrollLeft <= 1;
    var atEnd = row.scrollLeft >= max - 1;
    // No overflow at all: hide both fades.
    if (max <= 1) { atStart = true; atEnd = true; }
    host.classList.toggle('is-start', atStart);
    host.classList.toggle('is-end', atEnd);
  }

  function init(row) {
    if (row.dataset.dragScrollReady) { return; }
    row.dataset.dragScrollReady = '1';

    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    function onPointerDown(e) {
      // Only hijack mouse/pen drags; let touch use native scrolling.
      if (e.pointerType === 'touch') { return; }
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = row.scrollLeft;
      row.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!down) { return; }
      var dx = e.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) { moved = true; }
      row.scrollLeft = startScroll - dx;
      e.preventDefault();
    }

    function endDrag() {
      if (!down) { return; }
      down = false;
      row.classList.remove('is-dragging');
    }

    function onClickCapture(e) {
      // Swallow the click that ends a drag so links inside don't navigate.
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }

    row.addEventListener('pointerdown', onPointerDown);
    row.addEventListener('pointermove', onPointerMove);
    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointerleave', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    row.addEventListener('click', onClickCapture, true);

    row.addEventListener('scroll', function () { updateEdges(row); }, { passive: true });
    if (window.addEventListener) {
      window.addEventListener('resize', function () { updateEdges(row); });
    }
    updateEdges(row);
  }

  function initAll() {
    var rows = document.querySelectorAll('[data-drag-scroll]');
    for (var i = 0; i < rows.length; i++) { init(rows[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.BerryDragScroll = { init: init, initAll: initAll };
})();
